export const ValidateDate = (input: any) => {
    // Define current date for validation
    const d = new Date();
    const maximumDOBYear = d.getFullYear() - 18;
    const minimumDOBYear = d.getFullYear() - 100;

    // Check if input is a valid Date object string
    const parsedDate: Date = new Date(input);
    if (!isNaN(parsedDate.getTime())) {
        const year = parsedDate.getFullYear();
        return year >= minimumDOBYear && year <= maximumDOBYear;
    }

    if (parsedDate.toString() === "Invalid Date") {
        return false;
    }

    // Validate the input string format (DD/MM/YYYY)
    const dateRegex: RegExp = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const match = input.match(dateRegex);

    if (!match) {
        return false; // Invalid format
    }

    const [_, dayStr, monthStr, yearStr] = match;
    const day: number = parseInt(dayStr, 10);
    const monthNum: number = parseInt(monthStr, 10);
    const year: number = parseInt(yearStr, 10);

    // Check if year is within the valid range
    if (year < minimumDOBYear || year > maximumDOBYear) {
        return false;
    }

    // Validate month range
    if (monthNum < 1 || monthNum > 12) {
        return false;
    }

    // Validate day range based on the month and year
    const daysInMonth: number = new Date(year, monthNum, 0).getDate(); // Last day of the month
    if (day < 1 || day > daysInMonth) {
        return false;
    }

    return true; // Valid date
};